// closing-year-end-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'cye.notAvailableYet': 'El cierre del ejercicio aún no está disponible.',
  'cye.nuf.saved': 'La revisión NUF se ha guardado.',
  'cye.nuf.saveFailed': 'No se pudo guardar la revisión NUF.',
  'cye.nuf.headOfficeName': 'Nombre de la casa matriz',
  'cye.nuf.foreignRegistrationId': 'Número de registro extranjero',
  'cye.nuf.homeCountry': 'País de origen (código ISO)',
  'cye.nuf.homeLegalForm': 'Forma jurídica en el país de origen',
  'cye.nuf.framework': 'Marco contable',
  'cye.nuf.frameworkNorwegian': 'Principios contables noruegos (NGAAP)',
  'cye.nuf.frameworkHomeReconciled': 'Normas del país de origen, conciliadas con la sucursal noruega',
  'cye.nuf.taxNexus': 'Situación fiscal en Noruega',
  'cye.nuf.taxNexusTaxable': 'Se ha confirmado actividad sujeta a impuestos en Noruega',
  'cye.nuf.taxNexusExempt': 'La exención está confirmada profesionalmente',
  'cye.nuf.taxReturnDuty': 'Declaración de impuestos en Noruega',
  'cye.nuf.annualAccountsDuty': 'Cuentas anuales de la sucursal noruega',
  'cye.nuf.foreignAccountsAttachment': 'Cuentas anuales extranjeras como adjunto',
  'cye.nuf.mustFile': 'Debe presentarse',
  'cye.nuf.exemptAfterReview': 'No es obligatorio presentarla tras la evaluación profesional',
  'cye.nuf.notRequiredAfterReview': 'No es obligatorio tras la evaluación profesional',
  'cye.nuf.required': 'Obligatorio',
  'cye.nuf.homeCurrency': 'Moneda de origen',
  'cye.nuf.presentationCurrency': 'Moneda de presentación',
  'cye.nuf.allocationMethod': 'Método de asignación del resultado',
  'cye.nuf.allocationEvidence': 'Documentación de la asignación del resultado',
  'cye.nuf.filingEvidence': 'Documentación de las obligaciones de presentación',
  'cye.nuf.openingBalance': 'Saldo inicial con la casa matriz',
  'cye.nuf.transfersFrom': 'Transferido desde la casa matriz',
  'cye.nuf.transfersTo': 'Transferido a la casa matriz',
  'cye.nuf.allocatedResult': 'Resultado de la sucursal asignado',
  'cye.nuf.fxDifference': 'Diferencia de cambio',
  'cye.nuf.closingBalance': 'Saldo final con la casa matriz',
  'cye.nuf.branchAccountsPrepared': 'Las cuentas de la sucursal están elaboradas',
  'cye.nuf.foreignAccountsPrepared': 'Las cuentas anuales extranjeras están listas cuando se exigen',
  'cye.nuf.professionalReviewConfirmed': 'La evaluación contable, fiscal y de presentación ha sido revisada profesionalmente',
  'cye.nuf.expectedClosing': 'Saldo final esperado con la casa matriz: {expected} · diferencia {difference}',
  'cye.nuf.saving': 'Guardando…',
  'cye.nuf.save': 'Guardar revisión NUF',
});
